// extracted by mini-css-extract-plugin
module.exports = {"slider":"_1KkOT","slide":"_340mk"};